var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLetterUnsubscribe(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 196,
    height: 72,
    viewBox: "0 0 196 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M107.093 30.4497H103.928V32.7778H107.093V30.4497Z",
    fill: "#93C4E7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M100.733 30.4497H97.5674V32.7778H100.733V30.4497Z",
    fill: "#93C4E7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3882 30.4497H91.2227V32.7778H94.3882V30.4497Z",
    fill: "#93C4E7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M116.178 22.2301V7.36745H97.2268L97.2836 7.28228L88.0565 0L78.7301 7.36745H59.9353V22.2159L52 28.4761V71.2187H124.113V28.4761L116.178 22.2301ZM121.004 28.9872L116.192 32.7206V25.197L121.004 28.9872ZM88.0565 2.96685L93.6353 7.36745H82.4777L88.0565 2.96685ZM113.864 9.69551V34.5092L88.0565 54.4964L62.2633 34.5518V9.70971H113.864V9.69551ZM59.9353 32.749L55.0946 29.0014L59.9353 25.1828V32.749ZM54.3281 68.9048V31.3578L77.2679 49.1022L61.9368 61.4664L63.399 63.2834L79.1559 50.5643L88.0565 57.4491L96.9429 50.5785L112.7 63.2976L114.162 61.4806L98.8309 49.1022L121.785 31.3294V68.919H54.3281V68.9048Z",
    fill: "#93C4E7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M107.092 15.0615H69.0195V17.3896H107.092V15.0615Z",
    fill: "#93C4E7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M107.092 22.7554H69.0195V25.0834H107.092V22.7554Z",
    fill: "#93C4E7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M88.0557 30.4497H69.0195V32.7778H88.0557V30.4497Z",
    fill: "#93C4E7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M188.358 31.2441L190.209 35.3817L195.21 36.9127L190.209 38.4438L188.358 42.5813L186.507 38.4438L181.506 36.9127L186.507 35.3817L188.358 31.2441Z",
    fill: "#C3DFF1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M143.972 3.3374L149.779 19.0305L165.472 24.8374L149.779 30.6444L143.972 46.3374L138.165 30.6444L122.472 24.8374L138.165 19.0305L143.972 3.3374Z",
    fill: "#2EA1F8"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M18 14.2095L13.1384 27.3478L0 32.2095L13.1384 37.0711L18 50.2095L22.8616 37.0711L36 32.2095L22.8616 27.3478L18 14.2095Z",
    fill: "#2EA1F8"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M162.935 45.1978L166.176 53.9567L174.935 57.1978L166.176 60.4388L162.935 69.1978L159.693 60.4388L150.935 57.1978L159.693 53.9567L162.935 45.1978Z",
    fill: "#C3DFF1"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6353 2L40.486 6.13757L45.4874 7.6686L40.486 9.19964L38.6353 13.3372L36.7846 9.19964L31.7832 7.6686L36.7846 6.13757L38.6353 2Z",
    fill: "#C3DFF1"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M95.8141 15.1741C96.8541 13.9741 102.214 19.3341 101.014 20.3741L94.294 27.0653L100.934 33.7341C102.134 34.7741 96.7741 40.1341 95.7341 38.9341L89.0684 32.2684L82.3741 38.9341C81.3341 40.1341 75.9741 34.7741 77.1741 33.7341L83.8684 27.0684L77.1741 20.3741C76.0541 19.3341 81.4141 13.9741 82.4541 15.1741L89.1053 21.8541L95.8141 15.1741Z",
    fill: "#FFAB2B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLetterUnsubscribe);
export default __webpack_public_path__ + "static/media/Letter-unsubscribe.03f821f6.svg";
export { ForwardRef as ReactComponent };